import { makeStyles } from '@material-ui/core/styles';
import { kkColor, pzwoColor, ZWOreadyColor, totalColor } from './ProcessChart.styles';

export const useStyles = makeStyles(() => ({
  processBox: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    padding: '20px',
  },
  title: {
    fontSize: '16px',
    fontWeight: 900,
    marginBottom: '20px',
  },
  chartRow: {
    display: 'flex',
    marginBottom: '20px',
  },
  chartLabel: {
    width: '35px',
    fontSize: '14px',
    fontWeight: 900,
    color: 'rgba(44, 45, 62, 1)',
    position: 'relative',
    top: '-2px',
  },
  chart: {
    flexGrow: 10,
  },
  legendRow: {
    display: 'flex',
    fontSize: '12px',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    maxWidth: '400px',
  },
  legendLabel: {
    color: 'rgba(44, 45, 62, 1)',
  },
  legendValue: {
    fontWeight: 900,
    paddingLeft: '6px'
  },
  kkData: {
    color: kkColor,
    textAlign: 'left',
    flexGrow: 2,
  },
  pzwoData: {
    color: pzwoColor,
    textAlign: 'left',
    flexGrow: 2,
  },
  zwoReadyData: {
    color: ZWOreadyColor,
    textAlign: 'left',
    flexGrow: 2,
  },
  totalData: {
    color: totalColor,
    textAlign: 'left',
  },
}));
